export const onStateChangeEvent = formIndex => `${formIndex}-state-change`;
export const onValidationResultEvent = formIndex => `${formIndex}-validation-result`;

export const onValidationRequestEvent = formIndex => `${formIndex}:validate-controller`;
